import React, { useState } from 'react';
import { useContextInfo } from '../../context/ContextInfo';
import { fetchConToken } from '../../api/fetch';
import { Spinner } from 'react-bootstrap';

const CheckPon = ({ id, enable }) => {
    const [index, setIndex] = useState(enable);
    const [load, setload] = useState(false);
    const { setResp } = useContextInfo();
    const reloadPon = async (en) => {
        setload(true);
        if (load) return;
        setIndex(en);
        const r = await fetchConToken('fibra/ponreset', { id, enable: en }, 'PUT');
        setResp(r);
        setload(false);
    };
    return (
        <>
            {' '}
            {load ? (
                <Spinner size="sm" />
            ) : (
                <div className="form-group form-check" onClick={() => reloadPon(!index)}>
                    <input
                        type="checkbox"
                        className="form-check-input appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-500 checked:border-gray-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                        id="exampleCheck2"
                        name="rememberme"
                        checked={index}
                        readOnly
                    />
                </div>
            )}{' '}
        </>
    );
};
export default CheckPon;
